import { Box, Text } from '@doist/marketist'

import css from './alert.module.css'

type AlertProps = {
    children?: React.ReactNode
    includeTextWrapper?: boolean
}

export function Alert({ children, includeTextWrapper = true }: AlertProps) {
    return (
        <Box className={css.alert}>
            {includeTextWrapper ? <Text size="minor-base">{children}</Text> : children}
        </Box>
    )
}
